import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_DURATIONS } from 'ui-components/services/notification-service';

import messages from './messages';

export const removeProviderBundleSuccessNotification = {
  notificationType: NOTIFICATION_TYPE_SUCCESS,
  title: <FormattedMessage {...messages.removeBundleSuccessNotificationTitle} />,
  content: <FormattedMessage {...messages.removeBundleSuccessNotificationContent} />,
  duration: NOTIFICATION_DURATIONS.MEDIUM,
};

export const removeProviderBundleFailureNotification = {
  notificationType: NOTIFICATION_TYPE_ERROR,
  title: '',
  content: <FormattedMessage {...messages.removeBundleFailureNotificationContent} />,
  duration: NOTIFICATION_DURATIONS.MEDIUM,
};
